var PubSub = require("underpub-js");
var ComponentsLoader = require("./ComponentsLoader");
var QRious = require('qrious');
var Pjax = require("pjax");

/**
 * Sitewide
 */
var Sitewide = function(){

  

};

/**
 * Init
 */
Sitewide.prototype.init = function(){

    var self = this;

    this.initEvents();
    this.initArModals();
    this.inlineSvgs();

    // validate forms
    
    $('form').each(function() {
        $(this).validate({
            rules: {
                "email": {
                    email: true
                }
            },
            errorPlacement: function (error, element) {
                if (element.attr("type") == "radio") {
                    error.insertAfter($(element).closest('div'));
                } else if (element.attr("type") == "checkbox") {
                    error.insertAfter($(element).closest('div'));
                } else {
                    error.insertAfter(element);
                }
            }
        });
        $(this).find('.field.checkboxes.required input[type="checkbox"]').rules('add', {
            required: true
        });
    });
    
    // to enable PJAX, set App.usePjax to true in app.js
    if (App.usePjax)
    {

        // PJAX
        var pjax = new Pjax({
            elements: "a", // default is "a[href], form[action]"
            selectors: [".main", "head title"],
            switches: {
                ".main": Pjax.switches.innerHTML,
                "head title": Pjax.switches.innerHTML
            },
            cacheBust: false
        })

        
        document.addEventListener('pjax:send', function() {

            self.startTransition();

            PubSub.publish('hideMobileNavOverlay');

            window.pjaxSentTime = new Date().getTime();

        });

        // run the document load events when pjax completes to make sure we're finished
        document.addEventListener('pjax:complete', function() {

            App.documentOnLoad();

            self.inlineSvgs();

            console.log('pjax complete');

            console.log('pjax sent time: ' + window.pjaxSentTime);

            var currTime = new Date().getTime();

            console.log('curr time: ' + currTime);
            
            if ((currTime - window.pjaxSentTime) > 1000)
            {
                self.endTransition();

                self.scrollToUrlAnchor();
            }
            else
            {

                // set an interval that will end once we've hit our threshold

                var transitionTimerInterval = setInterval(function() {

                    var currTime = new Date().getTime();

                    if ((currTime - window.pjaxSentTime) > 1000)
                    {
                        self.endTransition();
                        window.clearInterval(transitionTimerInterval);

                        self.scrollToUrlAnchor();
                    }

                }, 100);

            }

        });

    }

    // smooth scroll anchor links
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });

};

/**
 * Init'ing our global events, many of which we publish
 */
Sitewide.prototype.initEvents = function(){

    //
    // Resizing (at the start)
    //
    var windowThrottled = _.throttle(function(e){
        PubSub.publish('resize');
    }, 0, {trailing: false});
    window.addEventListener("resize", windowThrottled, false);

    //
    // Resized Event (at the end)
    //
    var windowResizeDebounce = _.debounce(function(e) {
        PubSub.publish('resized');
    }, 400);
    window.addEventListener("resize", windowResizeDebounce, false);

};

Sitewide.prototype.initArModals = function(){

    $('[data-modal-ar-1]').each(function() {

        var $this = $(this);

        var qrToken = $this.data('token');
        var canvasElement = $this.find('.js_qrcode canvas').get(0);

        // Generate the QR code
        var qr = new QRious({
            element: canvasElement,
            value: qrToken,
            size: 120
        });

        $this.find('.background-overlay').click(function() {

            $this.removeClass('active').addClass('no-longer-shown');

        });

    });

    $('a[href*="#open-ar-modal-"]').click(function(event) {

        event.preventDefault();

        var thisHref = $(this).attr('href');

        var hrefArray = thisHref.split('#open-ar-modal-');

        var token = hrefArray[hrefArray.length - 1];

        $('[data-modal-ar-1][data-token=' + token + ']').addClass('active').removeClass('no-longer-shown');

    });

};

Sitewide.prototype.inlineSvgs = function(){

    /*
    * Replace all SVG images with inline SVG
    */
    $('img').filter(function() {
        return this.src.match(/.*\.svg/);
    }).each(function(){

        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img[0].src;

        if (imgURL.indexOf('?') >= 0) {
            var imgURL = imgURL + '&from-js=true';
        }
        else {
            var imgURL = imgURL + '?from-js=true';
        }

        $.ajax({
            url: imgURL,
            dataType: 'xml',
            success: function(data) {

                var $wrapperDiv = $('<div class="inline-svg-wrapper"></div>').insertBefore($img);
                
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // IE doesn't scale SVG properly so we need to use a canvas object
                if($svg.attr('height') && $svg.attr('width')) {
                    var $canvas = $('<canvas class="svg-frame" height="' + $svg.attr('height') + '" width="' + $svg.attr('width') + '"></canvas>');
                }
                else {
                    var $canvas = $('<canvas class="svg-frame" height="1" width="1"></canvas>');
                }

                $wrapperDiv.append($canvas);

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }

                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }

                // do not include height and width attributes on svg
                $svg.removeAttr('height');
                $svg.removeAttr('width');


                // Replace image with new SVG
                $wrapperDiv.append($svg);

                $img.remove();

            }
        });

    });

};

Sitewide.prototype.startTransition = function() {

    $('#transition').removeClass('no-longer-active').addClass('active');

};

Sitewide.prototype.endTransition = function() {
    $('#transition').removeClass('active').addClass('no-longer-active');
};

Sitewide.prototype.scrollToUrlAnchor = function() {
    var currUrlAnchor = location.hash.split('?')[0];

    if (currUrlAnchor != '')
    {
        $(window).scrollTop($(currUrlAnchor).offset().top);
    }
};

module.exports = Sitewide;
